import http from "../http-common";

class CategoryService {
    createCategory(data) {
      return http.post("category/create", data);
    }
    getCategories() {
        return http.get("category/list");
    }
    deleteCategory(data) {
      return http.delete("category/delete", { params: data });
  }
}

export default new CategoryService();